<template>
  <div class="registration-marketing">
    <div class="d-flex flex-column align-items-center">
      <h3 class="row mb-3 px-3">Do you want to hear about our updates and offers?</h3>
      <div class="row">
        <button class="btn mr-2" v-bind:class="{ 'btn-tertiary': marketing }" @click="setMarketingSetting(true)">
          Yes
        </button>
        <button class="btn ml-2" v-bind:class="{ 'btn-tertiary': !marketing }" @click="setMarketingSetting(false)">
          No
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapMutations } from 'vuex'

export default {
  name: 'MarketingSetting',
  computed: {
    ...mapState('ClientRegistrationUpload', [
      'notificationSettings'
    ]),
    marketing () {
      return this.notificationSettings.marketing
    }
  },
  methods: {
    ...mapMutations('ClientRegistrationUpload', [
      'setMarketingSetting'
    ])
  }
}
</script>

<style scoped>
.registration-marketing {
  border-block: 1px solid #ccc;
  padding-block: 1rem;
  margin-bottom: 1rem;
}
</style>
